import script from "./edit-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-table.vue?vue&type=script&setup=true&lang=ts"

import "./edit-table.vue?vue&type=style&index=0&id=0a3aa9e4&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a3aa9e4"]])

export default __exports__